import { render, staticRenderFns } from "./Frame.vue?vue&type=template&id=0cbfec19&scoped=true"
import script from "./Frame.vue?vue&type=script&lang=js"
export * from "./Frame.vue?vue&type=script&lang=js"
import style0 from "./Frame.vue?vue&type=style&index=0&id=0cbfec19&prod&lang=scss&scoped=true"
import style1 from "./Frame.vue?vue&type=style&index=1&id=0cbfec19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbfec19",
  null
  
)

export default component.exports